(() => {
  if (customElements.get('m-sim-selector')) return;
  class SimSelector extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.productFormId);
      this.onChange = () => {
        this.querySelector('.m-sim-bundle__error').textContent = '';
        this.update();
      };
      this.onVariant = (event) => {
        const id = String(event.detail?.variant?.id || '');
        if (!this.querySelector(`[data-sku-panel="${id}"]`)) return;
        this.activate(id);
      };
      this.onSubmit = (event) => this.submit(event);
      this.addEventListener('change', this.onChange);
      document.addEventListener('variant:changed', this.onVariant);
      document.addEventListener('submit', this.onSubmit, true);
      requestAnimationFrame(() => this.update());
      this.activate(this.form?.querySelector('[name="id"]')?.value || this.querySelector('[data-sku-panel]:not([hidden])')?.dataset.skuPanel);
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      document.removeEventListener('variant:changed', this.onVariant);
      document.removeEventListener('submit', this.onSubmit, true);
    }
    activate(id) {
      this.querySelectorAll('[data-sku-panel]').forEach(panel => { panel.hidden = panel.dataset.skuPanel !== String(id); });
      this.panel = this.querySelector('[data-sku-panel]:not([hidden])');
      if (!this.panel) return;
      const options = this.panel.querySelectorAll('input[type="radio"]');
      if (options.length === 1) options[0].checked = true;
      this.querySelector('.m-sim-bundle__error').textContent = '';
      this.update();
    }
    update() {
      if (!this.panel) return;
      this.form = document.getElementById(this.dataset.productFormId);
      const selected = this.panel.querySelector('input:checked');
      const addSim = this.panel.dataset.addSim === 'true';
      const hasNetworks = !!this.panel.querySelector('input');
      const heading = this.panel.querySelector('[data-network-heading]');
      const message = this.panel.querySelector('[data-network-message]');
      const networkName = selected?.value || '';
      const simUnavailable = addSim && selected && !selected.dataset.simId;
      if (heading) heading.textContent = networkName;
      if (message) {
        message.hidden = !networkName;
        message.textContent = simUnavailable
          ? `${networkName} SIM is currently unavailable. Please select another network.`
          : `Your selected network is ${networkName}`;
        message.classList?.toggle('is-unavailable', !!simUnavailable);
      }
      this.hidden = !hasNetworks && !addSim;
      this.valid = (!hasNetworks || !!selected) && (!addSim || !!selected?.dataset.simId);
      const allowSelectionPrompt = addSim && !selected && this.panel.querySelectorAll('input[type="radio"]').length > 1;
      this.panel.querySelectorAll('label').forEach(label => label.classList.toggle('is-selected', !!label.querySelector('input:checked')));
      if (!this.form) return;
      this.form.querySelectorAll('[name="add"]').forEach(button => {
        button.disabled = this.busy || (!this.valid && !allowSelectionPrompt) || this.panel.dataset.available !== 'true';
        button.classList.toggle('disabled', button.disabled);
        button.setAttribute('aria-disabled', String(button.disabled));
      });
      this.form.querySelectorAll('.shopify-payment-button').forEach(button => { button.hidden = addSim || hasNetworks; });
    }
    async submit(event) {
      this.form = document.getElementById(this.dataset.productFormId) || this.form;
      if (event.target !== this.form) return;
      const id = this.form.querySelector('[name="id"]')?.value;
      if (String(id) !== this.panel?.dataset.skuPanel) this.activate(id);
      if (!this.panel) return;
      if (!this.valid || this.busy) {
        event.preventDefault(); event.stopImmediatePropagation();
        this.querySelector('.m-sim-bundle__error').textContent = 'Please select an available network SIM before adding to cart.';
        return;
      }
      if (this.panel.dataset.addSim !== 'true') return;
      event.preventDefault(); event.stopImmediatePropagation();
      const formData = new FormData(this.form);
      const quantity = Number(formData.get('quantity') || 1);
      if (!Number.isInteger(quantity) || quantity < 1) return;
      const bundleId = `${id}-${Date.now()}`;
      const properties = { _bundle_id: bundleId };
      for (const [key, value] of formData.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match) properties[match[1]] = value;
      }
      const device = { id: Number(id), quantity, properties };
      if (formData.get('selling_plan')) device.selling_plan = formData.get('selling_plan');
      this.busy = true; this.update();
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [device, {
            id: Number(this.panel.querySelector('input:checked').dataset.simId), quantity,
            properties: { _bundle_id: bundleId }
          }] })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add device and SIM.');
        window.location.href = `${root}cart`;
      } catch (error) {
        this.querySelector('.m-sim-bundle__error').textContent = error.message;
      } finally { this.busy = false; this.update(); }
    }
  }
  customElements.define('m-sim-selector', SimSelector);
  document.addEventListener('variant:changed', event => {
    const id = String(event.detail?.variant?.id || '');
    document.querySelectorAll('[data-network-badges]').forEach(badges => {
      if (!badges.querySelector(`[data-badge-sku="${id}"]`)) return;
      badges.querySelectorAll('[data-badge-sku]').forEach(panel => { panel.hidden = panel.dataset.badgeSku !== id; });
    });
  });
})();
